import {Component , Inject , OnInit , ViewEncapsulation} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import {OrganizationsService} from '../../../../../core/services/organizations.service';
import {FrontUserService} from '../../../../../core/services/frontUsers.service';
import {EventTypeService} from '../../../../../core/services/eventType.service';
import {ToastrService } from 'ngx-toastr';
import { NgxSpinnerService } from 'ngx-spinner';
import {forkJoin, of} from 'rxjs';
import {tap} from 'rxjs/operators';
import {FuseDeleteDialogComponent} from '../../../../../core/components/delete-dialog/delete-dialog.component';
import {TranslateService} from '@ngx-translate/core';


@Component({
    selector: 'wizzard-form-dialog',
    templateUrl: './setting-form.component.html',
    styleUrls: ['./setting-form.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})

export class WizzardDialogComponent implements OnInit {
  readonly ALL_TG = {id: '__ALL__', name: 'wizzard.all'};
  users = [];
  targetGroups = [];
  eventType = [];
  all = false;
  migrationInProcess = false;
  migrationProgress = 0;
  migrationSuccess = false;
  migrationFailed = false;
  countdown  = 5;
  userTargetGroups = [];
  selectedTG: any = null;
  recentlyChangedUsers: any[] = [];

  constructor (private organizationService: OrganizationsService , private frontUser: FrontUserService ,
               public dialog: MatDialog , private eventService: EventTypeService ,
               public toastr: ToastrService , private spinner: NgxSpinnerService,
                public translate: TranslateService,
                public dialogRef: MatDialogRef<WizzardDialogComponent> ,
                @Inject(MAT_DIALOG_DATA) private data: any) {
    this.init();
  }

  init() {
    this.spinner.show();
    this.organizationService.getWizzardData(this.data.id).subscribe((res: any) => {
      const tgMap = new Map();
      for (let i = 0; i < res.length; i++) {
        if (res[ i ].canTrasfer > 0) {
          res[ i ].transfer = [];
          res[ i ].transfer.push({id: null , name: 'Transfer' , credit: res[ i ].canTrasfer});
        }
        if (res[i].targetGroup) {
          const tgId = res[i].targetGroup.id;
          if (!tgMap.has(tgId)) {
            tgMap.set(tgId, {...res[i].targetGroup, count: 1});
          } else {
            tgMap.get(tgId).count++;
          }
        } else {
          if (!tgMap.has(-1)) {
            tgMap.set(-1, {id: null, name: 'wizzard.no_target_group', count: 1});
          } else {
            tgMap.get(-1).count++;
          }
        }
      }
      this.userTargetGroups = Array.from(tgMap.values());
      if (this.userTargetGroups.length > 0) {
        this.selectedTG = this.userTargetGroups[0];
      }
      this.users = res;
      console.log(this.userTargetGroups);
    });
    this.frontUser.getTargetGroup().subscribe((res: any) => {
      this.targetGroups = res.targetGroups;
      this.spinner.hide();
    });

    this.eventService.getEventTypeDropDown().subscribe((res: any) => {
      this.eventType = res;
    });
  }

  get filteredUsers() {
    if (!this.selectedTG || this.selectedTG.id === '__ALL__') {
      return this.users;
    }
    if (this.selectedTG.id === null) {
      return this.users.filter(u => !u.targetGroup);
    }
    return this.users.filter(u => u.targetGroup && u.targetGroup.id === this.selectedTG.id);
  }

  compareTG(a: any, b: any): boolean {
    if (!a && !b) { return true; }
    if (!a || !b) { return false; }
    return a.id === b.id;
  }

  onTGChange() {
    for (let i = 0; i < this.users.length; i++) {
      this.users[i].selected = false;
    }
    this.all = false;
  }

  ngOnInit () {

  }

  openTgDialog (item , index) {
    const dialogRef = this.dialog.open(TGDialog , {
      width: '300px' ,
      data: {
        targetGroups: this.targetGroups ,
        selected: item ? item.id : null
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      for (let i = 0; i < this.targetGroups.length; i++) {
        if (this.targetGroups[ i ].id === result) {
          this.users[ index ].nextTG = this.targetGroups[ i ];
          break;
        }
      }
      console.log(result);
    });
  }

  openTransferDialog (tranfer , index) {
    const dialogRef = this.dialog.open(TransferDialog , {
      width: '450px' ,
      data: {
        eventType: this.eventType ,
        tranfer: tranfer
      }
    });

    dialogRef.afterClosed().subscribe(result => {

    });
  }

  selectAll() {
    const filtered = this.filteredUsers;
    for (let i = 0; i < filtered.length; i++) {
      filtered[i].selected = this.all;
    }
  }

  checkAll () {
    const filtered = this.filteredUsers;
    let count = 0;
    for (let i = 0; i < filtered.length; i++) {
      if (filtered[i].selected) {
        count++;
      }
    }
    this.all = filtered.length > 0 && filtered.length === count;
  }

  checkBeforeMigrate() {
    const thirtyDaysMs = 30 * 24 * 60 * 60 * 1000;
    const now = Date.now();
    this.recentlyChangedUsers = [];

    for (let i = 0; i < this.users.length; i++) {
      const user = this.users[i];
      if (user.selected && !!user.nextTG) {
        if (user.lastTimeChangeTG) {
          const diff = now - Number(user.lastTimeChangeTG);
          if (diff < thirtyDaysMs) {
            this.recentlyChangedUsers.push(user);
          }
        }
      }
    }

    if (this.recentlyChangedUsers.length > 0) {
      const names = this.recentlyChangedUsers
        .map(u => `${u.firstName} ${u.lastName}`)
        .join(', ');
      console.log(names);
      let dialog = this.dialog.open(FuseDeleteDialogComponent, {
        panelClass: 'unsave-form-dialog',
        width: '500px', height: 'auto',
        data: {title: 'migration_warning', message: 'migration_warning_msg', data: names}
      });
      dialog.afterClosed().subscribe(result => {
        if (result) {
          this.migrateUser();
        } else {
          let title = this.translate.instant('failure');
          let msg = this.translate.instant('migration_canceled');
          this.toastr.error(msg, title);
        }
      });
      return;
    }

    this.migrateUser();
  }

  migrateUser() {
    this.migrationInProcess = true;
    let requests = [];
    for (let i = 0; i < this.users.length; i++) {
      if (this.users[i].selected && !!this.users[i].nextTG) {
        let request = this.frontUser.migrateUser(this.users[i]).pipe(tap(() => console.log(`Request ${i + 1} finished`)));
        requests.push(request);
      }
    }
    if (requests.length === 0) {
      this.migrationInProcess = false;
      return;
    }
    let completedRequests = 0;
    const totalRequests = requests.length;

    const requestsWithProgress = requests.map(req$ =>
      req$.pipe(
        tap(() => {
          completedRequests++;
          this.migrationProgress = (completedRequests / totalRequests) * 100;
        })
      )
    );

    forkJoin(requestsWithProgress).subscribe({
      next: (results) => {
        this.migrationSuccess = true;
        this.updateProcess();
      },
      error: (error) => {
        this.migrationFailed = true;
        this.updateProcess();
      }
    });
  }

  updateProcess() {
    this.countdown = 5;
    const timer = setInterval(() => {
      this.countdown--;
      if (this.countdown <= 0) {
        clearInterval(timer);
        this.migrationInProcess = false;
        this.all = false;
        this.init();
      }
    }, 1000);
  }
}

@Component({
    selector: 'tg-example-dialog',
    templateUrl: 'tg-dialog.html',
    styles: `
    .tg-example-modal{
      padding: 20px;
    }
    `,
    standalone: false
})
export class TGDialog {
  constructor (public dialogRef: MatDialogRef<TGDialog> ,
               @Inject(MAT_DIALOG_DATA) public data: any) {
    console.log(data);
  }

  onNoClick (): void {
    this.dialogRef.close();
  }

}

@Component({
    selector: 'transfer-example-dialog',
    templateUrl: 'transfer-dialog.html',
    standalone: false
})
export class TransferDialog {
  selected;
  credit = 1;
  transferData;
  eventTypes = [];

  constructor (public dialogRef: MatDialogRef<TGDialog> ,
               @Inject(MAT_DIALOG_DATA) public data: any) {
    console.log(data);
    this.transferData = data.tranfer;
    this.eventTypes = data.eventType;
  }

  onNoClick (): void {
    this.dialogRef.close();
  }

  addNew (item , credit) {
    if (item && credit > 0 && (this.transferData[ 0 ].credit - credit) >= 0) {
      for (let i = 0; i < this.eventTypes.length; i++) {
        if (this.eventTypes[ i ].id === item) {
          this.transferData.push({name: this.eventTypes[ i ].name , id: this.eventTypes[ i ].id , credit: credit});
          this.transferData[ 0 ].credit = this.transferData[ 0 ].credit - credit;
        }
      }
    }
  }

  removeFromTranfer (index) {
    this.transferData[ 0 ].credit = this.transferData[ 0 ].credit + this.transferData[ index ].credit;
    this.transferData.splice(index , 1);
  }

}
